var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[(_vm.visible)?_c('v-alert',{staticClass:"notification-alert",attrs:{"type":_vm.type,"elevation":"10","border":"left","colored-border":""}},[_vm._v(" "+_vm._s(_vm.message)+" ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }